import React from "react";

import style from "./AnswerRespond.module.css";
import NextButton from "../nextButton/NextButton";
import Explanation from "../explanation/Explanation";
import Modal from "@/ui/modal/Modal";

import Container from "@/layouts/container/Container";
import Icon from "@/ui/icon/Icon";

import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

function AnswerRespond({
	dispatch,
	index,
	questions,
	quiz,
	answer,
	isCorrectAnswer,
	correctAnswer,
	explanation,
}) {
	const correctMessage = [
		"Tačan odgovor!",
		"Bravo!",
		"Svaka čast!",
		"Odlično!",
		"Sjajno!",
		"Fenomenalno!",
		"Super!",
		"Tako je!",
		"Odličan posao!",
	];

	return (
		<div
			className={`${style.answerRespond} ${
				isCorrectAnswer ? style.correct : style.wrong
			}`}
		>
			<Container size="medium">
				<div className={style.status}>
					<div className={style.icoHolder}>
						{isCorrectAnswer ? (
							<Icon icon="fa-badge-check" />
						) : (
							<Icon icon="fa-times" />
						)}
					</div>
					<div className={style.messageHolder}>
						<h4>
							{isCorrectAnswer
								? correctMessage[
										Math.floor(
											Math.random() *
												correctMessage.length
										)
									]
								: Math.random() == 0
									? "Vas odgovor je čista nula."
									: "Niste tačno odgovorili."}
						</h4>
						<p>
							{isCorrectAnswer ? (
								"Odgovorili ste tačno."
							) : (
								<>
									<span>Tačan odgovor je:</span>{" "}
									<Latex>{correctAnswer || ""}</Latex>
								</>
							)}
						</p>
					</div>
				</div>
				<div className={style.actions}>
					{explanation && (
						<Modal>
							<Modal.Open opens="explanation">
								<button className={style.explanationButton}>
									<Icon icon="fa-lightbulb" />
									<span>Prikaži objašnjenje</span>
								</button>
							</Modal.Open>
							<Modal.Window name="explanation" maxWidth="600px">
								<Explanation explanation={explanation} />
							</Modal.Window>
						</Modal>
					)}
					<div className={style.nextButton}>
						<NextButton
							index={index}
							numQuestions={questions.length}
							dispatch={dispatch}
							quiz={quiz}
							answer={answer}
						/>
					</div>
				</div>
			</Container>
		</div>
	);
}

export default AnswerRespond;
